const GLOBAL_SEARCH_STATS_API = '/api/globalsearch/stats';

/**
 * Track when search results are returned.
 * Returns an ID that should be used for click tracking.
 */
export async function trackSearchResultImpression(
	query: string,
	itemCount: number
): Promise<string | null> {
	try {
		if (!query) {
			console.warn("[Epifind] Attempted to track number of results for a null search query");
			return null;
		}
		const res = await fetch(GLOBAL_SEARCH_STATS_API, {
			body: JSON.stringify({
				Q: query,
				ItemCount: itemCount,
			}),
			headers: {
				"Content-Type": "application/json",
			},
			method: "POST"
		});
		const data = await res.json();
		return data?.id ?? null;
	} catch (err) {
		console.error('[Epifind] Failed to track search impression', err);
		return null;
	}
}

/**
 * Track when a user clicks a search result.
 * Does not block navigation.
 */
export function trackSearchResultClick(params: {
	query: string;
	itemGuid: string;
	trackId: string;
}): void {
	const { query, itemGuid, trackId } = params;

	if (!query) {
		console.warn("[Epifind] Attempted to track a null search query hit");
		return;
	}

	const data = JSON.stringify({ Q: query, Guid: itemGuid, Id: trackId });
	const blob = new Blob([data], {type: 'application/json;charset=UTF-8'});

	try {
		navigator.sendBeacon?.(GLOBAL_SEARCH_STATS_API, blob);
	} catch (err) {
		console.error('[Epifind] Failed to track search click', err);
	}
}
